import React, { useState, useRef } from 'react';

import { Growl } from 'primereact/growl';
import { Lista } from './Lista';
import { Formulario } from './Formulario';

import servicioObjetos from '../../../servicio/ServicioObjetos';
import servicioHttp from '../../../servicio/ServicioHttp';

export const ConfiguracionDescargaCfdi = (props) => {

    const [empresa, setEmpresa] = useState(null);
    const [tcFielDb, setTcFielDb] = useState(null);
    let growl = useRef(null);

    const onSeleccionEmpresa = (empresaSeleccionada) => {
        setEmpresa(empresaSeleccionada);
        let idEmpresa = empresaSeleccionada.value;
        servicioHttp.consumirPostHttp('fiel/buscar_por_empresa.json', { id: idEmpresa }).then(response => {
            setTcFielDb(response.data.objeto);
        }).catch(error => {
            growl.current.show({ severity: 'error', summary: 'Error', detail: "Existe un error de conexión con el servidor, contacte a un administrador", life: 10000 });
        });
    }

    const onFormularioOk = (objetoFormulario) => {
        if (servicioObjetos.esObjetoVacio(empresa)) {
            growl.current.show({ severity: 'error', summary: 'Error', detail: "Debes de elegir una empresa", life: 10000 });
            return;
        }

        if (!servicioObjetos.esObjetoVacio(tcFielDb) && !servicioObjetos.esObjetoVacio(tcFielDb.id)){
            objetoFormulario.id = tcFielDb.id;
            objetoFormulario.fechaInsercion=tcFielDb.fechaInsercion;
            objetoFormulario.fechaActualizacion=new Date();
        }else{
            objetoFormulario.fechaInsercion=new Date();
        }
            

        if (!servicioObjetos.esObjetoVacio(objetoFormulario)) {
            objetoFormulario.tcEmpresa = { id: empresa.value };
            servicioHttp.consumirPostHttp('fiel/guardar.json', objetoFormulario).then(response => {
                let data = response.data;
                growl.current.show({ severity: data.error ? 'error' : 'success', summary: data.error ? 'Error' : 'Éxito', detail: data.mensaje, life: 10000 });
            }).catch(error => {
                growl.current.show({ severity: 'error', summary: 'Error', detail: "Existe un error de conexión con el servidor, contacte a un administrador", life: 10000 });
            });
        }

    }

    return (
        <div>
            <Growl ref={growl} />
            <div className="p-grid">
                <div className="p-col-12">
                    <div className="card">
                        <h1>Configuración descarga de Cfdi</h1>
                        <p>En este módulo usted puede realizar la configuración para poder descargar los CFDI del SUA y de Nómina</p>
                    </div>
                </div>
            </div>
            <div className="p-grid">
                <div className="p-col-12">
                    <div className="card">
                        <Lista onSeleccionEmpresa={onSeleccionEmpresa} />
                    </div>
                </div>
            </div>
            <div className="p-grid">
                <div className="p-col-12">
                    <div className="card">
                        <Formulario onFormularioOk={onFormularioOk} growl={growl}/>
                    </div>
                </div>
            </div>
        </div>

    );
}